module.exports = __webpack_public_path__ + "img/illinoisAdventure@1x.eeca2468.webp";